import { Pin } from 'lucide-react';
import Link from 'next/link';

import Avatar from '../common/Avatar';

type Props = {
  avatar:
    | { spaceAvatarKey: string | null }
    | { factiiiAvatarKey: string | null; factiiiId: number };
  href: string;
  name: string;
  description: string | null;
  pinned?: boolean;
  onTogglePin?: () => void;
};

const SpaceCard = (props: Props) => {
  const isFactiiiAvatar = 'factiiiAvatarKey' in props.avatar;

  return (
    <Link
      href={props.href}
      className="ml-1 flex items-center rounded-lg border border-ds-border-subtle bg-background-light py-6 pl-3 pr-1 transition-all duration-200 hover:border-ds-border-hover hover:bg-background-light"
    >
      {isFactiiiAvatar ? (
        <Avatar
          size={40}
          factiiiAvatarKey={
            (
              props.avatar as {
                factiiiAvatarKey: string | null;
                factiiiId: number;
              }
            ).factiiiAvatarKey
          }
          factiiiId={
            (
              props.avatar as {
                factiiiAvatarKey: string | null;
                factiiiId: number;
              }
            ).factiiiId
          }
        />
      ) : (
        <Avatar
          size={40}
          spaceAvatarKey={
            (props.avatar as { spaceAvatarKey: string | null }).spaceAvatarKey
          }
        />
      )}
      <div className="ml-3 min-w-0 flex-1 text-start">
        <h4 className="truncate font-emphasis">{props.name}</h4>
        <p
          className="mr-2 truncate text-base text-textSecondary/70"
          style={{
            fontStyle: props.description ? 'normal' : 'italic'
          }}
        >
          {props.description ?? 'No description provided'}
        </p>
      </div>
      {props.onTogglePin && (
        <button
          title={props.pinned ? 'Unpin space' : 'Pin space'}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            props.onTogglePin?.();
          }}
          className={`mr-2 shrink-0 rounded-full p-1.5 transition-colors duration-150 ${
            props.pinned
              ? 'text-primary'
              : 'text-textSecondary/50 hover:text-primary'
          }`}
        >
          <Pin size={16} className={props.pinned ? 'fill-primary' : ''} />
        </button>
      )}
    </Link>
  );
};

export default SpaceCard;
